import type { Draft } from "../../../../packages/shared/src/types";

// An explicit Send action, separate from the durable proof of a submitted request.
export interface SendIntent {
  id: string;
  draftId: string;
  contents: string;
  accountId?: string;
  createdAt: number;
}
export function draftContents(draft: Draft): string {
  const { updatedAt, pendingSend, clientRequestId, shareToken, senderUserId, sentCardId, ...contents } = draft;
  return JSON.stringify(contents);
}
export function canContinueSend(intent: SendIntent, draft: Draft, accountId?: string): boolean {
  return !draft.sentCardId && intent.draftId === draft.id &&
    intent.contents === draftContents(draft) &&
    (!intent.accountId || intent.accountId === accountId) &&
    (!draft.senderUserId || draft.senderUserId === accountId);
}
export function restoreSendIntent(raw: string | null, nonce: string | null, draft: Draft, accountId?: string): SendIntent | null {
  if (!raw || !nonce || !accountId) return null;
  try {
    const intent = JSON.parse(raw) as SendIntent;
    const age = Date.now() - intent.createdAt;
    return intent.id === nonce && Number.isFinite(age) && age >= 0 && age < 30 * 60_000 &&
      canContinueSend(intent, draft, accountId) ? { ...intent, accountId } : null;
  } catch { return null; }
}
